module.exports = __webpack_public_path__ + "images/stickers/pete-sketch.6e17baf06870f4bd1c30.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-sketch.png
// module id = tP9N
// module chunks = 13